/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Scope_Output5Inputs */

const en_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retainer agreement`)
};

const ar_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتفاقية العقد`)
};

const bn_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিটেইনার চুক্তি`)
};

const de_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retainer-Vereinbarung`)
};

const es_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acuerdo de retainer`)
};

const fr_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convention de forfait`)
};

const pt_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acordo de avença`)
};

const zh_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包月协议`)
};

const tr_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retainer sözleşmesi`)
};

const ru_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор ретейнера`)
};

const pl_svc_retainer_scope_output5 = /** @type {(inputs: Svc_Retainer_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowa retainera`)
};

/**
* | output |
* | --- |
* | "Retainer agreement" |
*
* @param {Svc_Retainer_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_scope_output5 = /** @type {((inputs?: Svc_Retainer_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_scope_output5(inputs)
	if (locale === "bn") return bn_svc_retainer_scope_output5(inputs)
	if (locale === "de") return de_svc_retainer_scope_output5(inputs)
	if (locale === "es") return es_svc_retainer_scope_output5(inputs)
	if (locale === "fr") return fr_svc_retainer_scope_output5(inputs)
	if (locale === "pt") return pt_svc_retainer_scope_output5(inputs)
	if (locale === "zh") return zh_svc_retainer_scope_output5(inputs)
	if (locale === "tr") return tr_svc_retainer_scope_output5(inputs)
	if (locale === "ru") return ru_svc_retainer_scope_output5(inputs)
	if (locale === "pl") return pl_svc_retainer_scope_output5(inputs)
	return en_svc_retainer_scope_output5(inputs)
});
export { svc_retainer_scope_output5 as "svc_retainer_SCOPE_output" }